import MockAdapter from 'axios-mock-adapter';
import { 
  getRequestItemsByWorkOrder, 
  getRequestItemById, 
  createRequestItem, 
  updateRequestItem, 
  deleteRequestItem,
  getRequestItemTypes,
  getRequestItemUnits
} from './requestItems';
import type { RequestItem } from './requestItems';

export const setupRequestItemsRoutes = (mock: MockAdapter) => {
  // GET /api/workorders/:id/requestitems - Obtener request items por work order
  mock.onGet(/\/api\/workorders\/(\d+)\/requestitems/).reply((config) => {
    const workOrderId = parseInt(config.url!.match(/\/api\/workorders\/(\d+)\/requestitems/)![1]);
    const items = getRequestItemsByWorkOrder(workOrderId);
    
    return [200, {
      success: true,
      data: items,
      total: items.length
    }];
  });

  // GET /api/requestitems/types - Obtener tipos disponibles
  mock.onGet('/api/requestitems/types').reply(() => {
    return [200, {
      success: true,
      data: getRequestItemTypes()
    }];
  });

  // GET /api/requestitems/units - Obtener unidades disponibles
  mock.onGet('/api/requestitems/units').reply(() => {
    return [200, {
      success: true,
      data: getRequestItemUnits()
    }];
  });

  // GET /api/requestitems/:id - Obtener request item específico
  mock.onGet(/\/api\/requestitems\/(\d+)/).reply((config) => {
    const id = parseInt(config.url!.match(/\/api\/requestitems\/(\d+)/)![1]);
    const item = getRequestItemById(id);
    
    if (!item) {
      return [404, {
        success: false,
        message: 'Request item no encontrado'
      }];
    }
    
    return [200, {
      success: true,
      data: item
    }];
  });

  // POST /api/requestitems - Crear nuevo request item
  mock.onPost('/api/requestitems').reply((config) => {
    try {
      const newItemData = JSON.parse(config.data);
      
      // Validación básica
      if (!newItemData.workOrderId || !newItemData.description || !newItemData.quantity) {
        return [400, {
          success: false,
          message: 'Datos incompletos'
        }];
      }

      const newItem = createRequestItem({
        workOrderId: newItemData.workOrderId,
        itemType: newItemData.itemType || 'Material',
        description: newItemData.description,
        quantity: parseFloat(newItemData.quantity),
        unit: newItemData.unit || 'Unidad',
        unitPrice: parseFloat(newItemData.unitPrice) || 0,
        totalPrice: 0, // Se calculará automáticamente
        status: 'PENDING',
        requestedBy: newItemData.requestedBy || 'Usuario Sistema',
        requestedDate: new Date().toISOString(),
        notes: newItemData.notes
      });

      return [201, {
        success: true,
        data: newItem,
        message: 'Request item creado exitosamente'
      }];
    } catch (error) {
      return [400, {
        success: false,
        message: 'Error en los datos proporcionados'
      }];
    }
  });

  // PUT /api/requestitems/:id - Actualizar request item
  mock.onPut(/\/api\/requestitems\/(\d+)/).reply((config) => {
    try {
      const id = parseInt(config.url!.match(/\/api\/requestitems\/(\d+)/)![1]);
      const updateData = JSON.parse(config.data);
      
      const updatedItem = updateRequestItem(id, updateData);
      
      if (!updatedItem) {
        return [404, {
          success: false,
          message: 'Request item no encontrado'
        }];
      }

      return [200, {
        success: true,
        data: updatedItem,
        message: 'Request item actualizado exitosamente'
      }];
    } catch (error) {
      return [400, {
        success: false,
        message: 'Error en los datos proporcionados'
      }];
    }
  });

  // DELETE /api/requestitems/:id - Eliminar request item
  mock.onDelete(/\/api\/requestitems\/(\d+)/).reply((config) => {
    const id = parseInt(config.url!.match(/\/api\/requestitems\/(\d+)/)![1]);
    const deleted = deleteRequestItem(id);
    
    if (!deleted) {
      return [404, {
        success: false,
        message: 'Request item no encontrado'
      }];
    }

    return [200, {
      success: true,
      message: 'Request item eliminado exitosamente'
    }];
  });
};
